<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 设备管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>

           <div class='handle-box'>
            <el-select v-model='enterpriseSearchId' placeholder='企业' style='width: 140px;margin-right: 20px'>
                <el-option
                    v-for='item in enterpiseOptionsSearch'
                    :key='item.value'
                    :label='item.label'
                    :value='item.value'>
                </el-option>
            </el-select>
               <el-select v-model='groupSearchId' placeholder='消费组' style='width: 140px;margin-right: 20px'>
                   <el-option
                       v-for='item in groupSearchOption'
                       :key='item.value'
                       :label='item.label'
                       :value='item.value'>
                   </el-option>
               </el-select>

               <el-input v-model='query.consumptionCode' placeholder='设备消费码' class='handle-input mr10'
                         style='width: 140px;margin-right: 20px'></el-input>
                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>
                <el-button
                    type='primary'
                    icon='el-icon-plus'
                    class='handle-del mr10'
                    @click='addUser'
                >添加设备
                </el-button>
            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >
                <el-table-column type='selection' width='55' align='center' v-if='false'></el-table-column>
                <el-table-column label='序号' align='center' :index='indexMethod' width='40' type='index'>

                </el-table-column>
                <el-table-column label='单位' align='center' >
                    <template slot-scope='scope'>{{ scope.row.enterpriseName }}</template>
                </el-table-column>
                <el-table-column label='设备名称' align='center'>
                    <template slot-scope='scope'>{{ scope.row.termName }}</template>
                </el-table-column>
                <el-table-column label='消费组' align='center'>
                    <template slot-scope='scope'>{{ scope.row.groupName}}</template>
                </el-table-column>
                <el-table-column label='设备SN编号' align='center'>
                    <template slot-scope='scope'>{{ scope.row.consumptionCode }}</template>
                </el-table-column>
                <el-table-column label='消费编号' align='center'>
                    <template slot-scope='scope'>{{ scope.row.deviceSn }}</template>
                </el-table-column>
                <el-table-column label='设备位置' align='center'>
                    <template slot-scope='scope'>{{ scope.row.termlocation }}</template>
                </el-table-column>
                <el-table-column label='状态' align='center'>
                    <template slot-scope='scope'>{{ scope.row.isOnline==1?"在线": '离线' }}</template>
                </el-table-column>
                <el-table-column label='心跳时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.lastHeatTime }}</template>
                </el-table-column>
                <el-table-column prop='createTime' label='创建时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.createTime }}</template>

                </el-table-column>
                <el-table-column label='操作' width='180' align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            icon='el-icon-edit'
                            @click='handleEdit(scope.$index, scope.row)'
                        >编辑
                        </el-button>
                        <el-button
                            type='text'
                            icon='el-icon-delete'
                            class='red'
                            @click='handleDelete(scope.$index, scope.row)'
                        >删除
                        </el-button>

                    </template>
                </el-table-column>

            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>

        <el-dialog title='编辑场地' :visible.sync='editVisible' width='40%'>



            <el-form ref='form' :model='form' label-width='90px'>
                <el-form-item label='所属企业'>
                    <el-select v-model='enterpriseId' placeholder='请选择'     disabled >
                        <el-option
                            v-for='item in enterpiseOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label='设备组'>
                    <el-select v-model='groupId' placeholder='请选择'   >
                        <el-option
                            v-for='item in groupOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label='设备名称'>
                    <el-input v-model='form.termName'></el-input>
                </el-form-item>

                <el-form-item label='设备SN编码'>
                    <el-input v-model='form.consumptionCode'></el-input>
                </el-form-item>
                <el-form-item label='消费编码'>
                    <el-input v-model='form.deviceSn'></el-input>
                </el-form-item>
                <el-form-item label='终端位置'>
                    <el-select v-model='placeId' placeholder='请选择'   >
                        <el-option
                            v-for='item in placeOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='备注'>
                    <el-input v-model='form.remark'></el-input>
                </el-form-item>
            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='editVisible = false'>取 消</el-button>
                <el-button type='primary' @click='editHttp'>确 定</el-button>
            </span>
        </el-dialog>


        <!-- 添加用户 -->
        <el-dialog title='添加设备' :visible.sync='addVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='160px'>
                <el-form-item label='所属企业'>
                    <el-select v-model='enterpriseId' placeholder='请选择'   >
                        <el-option
                            v-for='item in enterpiseOptions'
                            :key='item.value'
                            :label='item.label'

                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label='设备组'>
                    <el-select v-model='groupId' placeholder='请选择'   >
                        <el-option
                            v-for='item in groupOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label='设备名称'>
                    <el-input v-model='createForm.termName'></el-input>
                </el-form-item>
                <el-form-item label='设备SN编码(16位数字)'>
                    <el-input v-model='createForm.consumptionCode'></el-input>
                </el-form-item>
                <el-form-item label='消费编码(8位数字)'>
                    <el-input v-model='createForm.deviceSn'></el-input>
                </el-form-item>
                <el-form-item label='终端位置'>
                    <el-select v-model='placeId' placeholder='请选择'   >
                        <el-option
                            v-for='item in placeOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label='备注'>
                    <el-input v-model='createForm.remark'></el-input>
                </el-form-item>
            </el-form>

            <span slot='footer' class='dialog-footer'>
                        <el-button @click='addVisible = false'>取 消</el-button>
                        <el-button type='primary' @click='addUserHttp'>确 定</el-button>
                    </span>
        </el-dialog>
    </div>
</template>

<script>
import { countDown, formatDate, formatDates } from '@/utils/formatDate';

export default {
    name: 'basetable',
    data() {
        return {
            amountIsShow:"1",
            camountIsShow:"1",
            enterpriseId:"",
            isDiscount:"0",
            queryEnterprise: {
                name: '',
                pageIndex: 1,
                pageSize: 999999
            },
            enterpiseOptions: [],
            enterpiseValue: '',
            mealOptions:[],
            cardOptions:[],
            mealValue: '',
            enterpriseSearchId:'',
            query: {
                name: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible: false
            ,
            createForm: {
                mealIds:"",
                cardIds:"",
                remark:"",
            }
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            options: [],
            value: '',
            editCurrentProgress: '1',
            editCurrentProgressName: '',
            enterpiseOptionsSearch:[],
            groupOptions : [],
            groupId: "",
            placeOptions:[],
            placeId:"",
            groupSearchOption:[],
            groupSearchId:'',


        };
    },
    watch:{
        enterpriseId(newV,oldV){
            this.groupOptions=[];
            this.cardOptions=[]
            this.getDeviceGroup();
            this.getPlaceList();
        },
        enterpriseSearchId(newV,oldV){
            this.groupSearchOption=[];
            this.groupSearchId=''

            this.getDeviceSearchGroup();

        }
    },
    created() {
        this.getEnterpise();
        this.getData();
        this.getEnterpiseSearch();



    },


    methods: {

        getEnterpise() {
            let that = this;
            this.http.getToken('enterprise/getList', this.queryEnterprise).then(res => {
                    if (res.code == 0) {
                        that.enterpiseOptions=[]
                        that.enterpiseOptions.push({ 'value': '', 'label': '请选择企业' });
                        res.data.records.forEach(res => {
                            that.enterpiseOptions.push({ 'value': res.id+"", 'label': res.name });
                        });

                    }
                },
                err => {


                });
        },
        getPlaceList() {
            let that = this;
            this.http.getToken('place/getPlaceList', {"enterpriseId":this.enterpriseId,"pageIndex":1,"pageSize":99999}).then(res => {

                    if (res.code == 0) {
                        that.placeOptions=[]
                        that.placeOptions.push({"label":"请选择场地","value":""})
                        res.data.records.forEach(res => {


                       that. placeOptions.push({"label":res.name,"value":res.id+""})


                        });

                    }
                },
                err => {

                });
        },
        getDeviceGroup() {
            let that = this;
            this.http.getToken('device/getDeviceGroupList', {"enterpriseId":this.enterpriseId,"pageIndex":1,"pageSize":99999}).then(res => {
                    if (res.code == 0) {
                        that.groupOptions=[]
                        that.groupOptions.push({"label":"请选择消费组","value":""})
                        res.data.records.forEach(res => {

                         that. groupOptions.push({"label":res.name,"value":res.id+""})


                        });

                    }
                },
                err => {

                });
        },
        getDeviceSearchGroup() {
            let that = this;
            this.http.getToken('device/getDeviceGroupList', {"enterpriseId":this.enterpriseSearchId,"pageIndex":1,"pageSize":99999}).then(res => {


                    if (res.code == 0) {
                        that.groupSearchOption=[]
                        that.groupSearchOption.push({"label":"请选择消费组","value":""})
                        res.data.records.forEach(res => {

                            that. groupSearchOption.push({"label":res.name,"value":res.id+""})


                        });

                    }
                },
                err => {

                });
        }

        ,
        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';
            if (row.status == 1) {
                msg = '确定要' + '禁用' + '吗？';
                params = { 'id': row.id, 'status': 0 };
            } else {
                msg = '确定要' + '解除禁用' + '吗？';
                params = { 'id': row.id, 'status': 1 };
            }

            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('device/updateStatusDeviceGroupById', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        indexMethod(index) {
            return index + 1;
        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.getData();

        }
        ,
        getEnterpiseSearch() {
            let that = this;
            this.http.getToken('/enterprise/getList', this.queryEnterprise).then(res => {
                    if (res.code == 0) {
                        that.enterpiseOptionsSearch.push({ 'value': '', 'label': '请选择企业' });
                        res.data.records.forEach(res => {
                            that.enterpiseOptionsSearch.push({ 'value': res.id, 'label': res.name });
                        });

                    }
                },
                err => {

                });
        },
        getData() {
            let that = this;
            this.query.enterpriseId=this.enterpriseSearchId
            this. query.groupSearchId=this.groupSearchId
            this.http.getToken('device/getList', this.query).then(res => {
                    if (res.code == 0) {
                        that.tableData = res.data.records;
                        that.pageTotal = parseInt(res.data.total);
                        this.$message.success('获取数据成功');

                    }
                },
                err => {

                });
        },
        delUserHttp(id) {
            let that = this;
            this.http.postToken('device/delById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {


            this.mealOptions=[];
            this.createForm.mealIds='';
            this.cardOptions=[]
            this.createForm.cardIds='';
            this.createForm = {};
            this.enterpriseId=''
            this.cardOptions=[]
            this.addVisible = true;
        },

        addUserHttp() {

            let that = this;
            this.createForm.enterpriseId=this.enterpriseId;
            this.createForm.deviceGroupId =this.groupId
            this.createForm.termlocationId = this.placeId


            this.http.postToken('device/add', this.createForm).then(res => {
                if (res.code === 0) {
                    this.createForm = {};
                    this.enterpriseId=''
                    that.getData();
                    that.addVisible = false;
                    this.$message.success('添加成功');
                }

            });
        }
        ,
        editHttp() {
            let that = this;
            this.form.enterpriseId=this.enterpriseId;
            this.form.deviceGroupId=this.groupId;
            this.form.termlocationId=this.placeId;

            this.http.postToken('device/edit', this.form).then(res => {
                if (res.code == 0) {
                    that.getData();
                    that.editVisible = false;
                    that.$message.success('编辑成功');
                }

            });
        }
        ,
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;

            this.form = JSON.parse(JSON.stringify(row));
            this.enterpriseId=this.form.enterpriseId+""
            this.getEnterpise()
            this.groupId = this.form.deviceGroupId+""
            this.placeId = this.form.termlocationId+""
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
